
export class authApi {
    public static GET_CURRENT_USER(): string {
        return `/user/current`;
    }

    public static UPDATE(emailAlt: string | null, phone: string | null, provincia: string | null): [string, any] {
        return [`/user/update`, {emailAlt: emailAlt, phone: phone, provincia: provincia}];
    }

    public static UPDATE_USER_CHANNELS(email: boolean, appio: boolean): [string, any] {
        return [`/user/update/channels`, {email: email, appio: appio}];
    }

    public static UPDATE_TITOLALRE(): string {
        return `/titolare/create`;
    }

    public static GET_TITOLARI(active?: boolean, filterText?: string): string {
        if (active == undefined) active = true;
        return `/user/getTitolari${active ? '?active=false' : '?active=true'}${filterText ? '&filterText=' + filterText : ''}`;
    }

    public static GET_TITOLARI_BY_CAMPAGNA(campagnaId: number): string {
        return `/user/getTitolariByCampagna?campagnaId=${campagnaId}`;
    }

    public static GET_DELEGHE_TITOLARE(titolareId: string): string {
        return `/titolare/${titolareId}/getDelega`;
    }

    public static GET_TITOLARE_UTENTE(userCf: string, titolareCf: string): string {
        return `/titolare/find?utente=${userCf}&titolare=${titolareCf}`;
    }

    public static GET_PERSONA_GIURIDICA(code: string): string {
        return `/titolare/aris?code=${code}`;
    }

    //Titolare
    public static GET_DATI_TITOLARE(titolariId: string | number, tipo: string): string {
        return `/dati-titolare/all/${titolariId}/${tipo}`;
    }

    public static GET_DATI_TITOLARE_EXTERNAL_URL(titolariId: string | number, catalogoId: string): string {
        return `/dati-titolare/external/${titolariId}/${catalogoId}`;
    }

    public static REVOCA_DELEGA(id: number) {
        return `/titolare/revocaDelega/${id}`;
    }

    public static UPLOAD_DELEGA(formData: FormData): [string, any] {
        return [`/titolare/uploadDelega`, formData];

    }

    public static GET_ALEGATO_DELEGA(id: number): string {
        return `/titolare/downloadDelega/${id}`;

    }

}
